(function () {
  const initPopup = (root) => {
    if (!root || root.dataset.popupReady) return;
    root.dataset.popupReady = 'true';

    const delay = Math.max(0, parseInt(root.dataset.delay, 10) || 0) * 1000;
    const backdrop = root.querySelector('.popup-clearance__backdrop');
    const dialog = root.querySelector('.popup-clearance__dialog');

    const open = () => {
      root.hidden = false;
      requestAnimationFrame(() => root.classList.add('is-open'));
      document.body.classList.add('popup-clearance-open');
      dialog?.focus();
    };

    const close = () => {
      root.classList.remove('is-open');
      document.body.classList.remove('popup-clearance-open');
      window.setTimeout(() => {
        if (!root.classList.contains('is-open')) root.hidden = true;
      }, 260);
    };

    root.querySelectorAll('[data-popup-close]').forEach((el) => {
      el.addEventListener('click', (event) => {
        event.preventDefault();
        close();
      });
    });

    backdrop?.addEventListener('click', close);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    window.setTimeout(open, delay);
  };

  window.initPopupClearance = function (root) {
    initPopup(root || document.querySelector('.popup-clearance'));
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.popup-clearance:not([data-popup-ready])').forEach(initPopup);
  });
})();
